// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import Loader from '../../../common/Loader';
import RoiKpi from './RoiKpi';
import {
  computePayback,
  formatMgr,
  formatPayback,
  formatRoi,
  formatRoiParam,
  formatTic,
} from '../../../../utils/formatUtils';
import type { RoiBpParams } from '../../../../types/apolloType';

type Props = {
  resultLoading: boolean,
  title: string,
  titleDetails: string,
  focus: string,
  showDetails: any,
  businessPlan: RoiBpParams,
}

function RoiPanelBpResult(props: Props) {
  const getContent = () => {
    if (props.resultLoading) {
      return (
        <Loader isLoading message={<Translate value="roi.computing" />} />
      );
    }
    if (props.businessPlan) {
      return (
        <>
          <div className="roi-result">
            <RoiKpi
              kpiValue={formatRoi(props.businessPlan.roi, props.businessPlan.mgrUplift, props.businessPlan.tic)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatPayback(computePayback(props.businessPlan.mgrUplift, props.businessPlan.tic))}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatMgr(props.businessPlan.newMgrGlaNet)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatMgr(props.businessPlan.mgrUplift)}
              isFocus={props.focus === 'mgr'}
              isPositive={props.businessPlan.mgrUplift > 0}
            />
            <RoiKpi
              kpiValue={formatRoiParam(props.businessPlan.tic)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatTic(props.businessPlan.keyMoney)}
              isFocus={props.focus === 'keymoney'}
              isPositive={props.businessPlan.keyMoney > 0}
            />
            <RoiKpi
              kpiValue={formatRoiParam(props.businessPlan.valueCreationVsCurrent)}
              isFocus={false}
            />
            <RoiKpi
              kpiValue={formatRoiParam(props.businessPlan.incentives)}
              isFocus={props.focus === 'incentives'}
              isPositive={props.businessPlan.incentives > 0}
            />
          </div>
          <div className="roi-button-container">
            <button
              type="button"
              className="apollo-button-contained details-button"
              onClick={() => props.showDetails(true)}
            >
              <div className="button-big-text">
                <Translate value="roi.details" />
              </div>
            </button>
          </div>
        </>
      );
    }
    return (
      <div className="roi-result" />
    );
  };
  return (
    <div className="roi-panel roi-panel-kpi">
      <h3 className="roi-subtitle">
        {props.title}
        <Translate className="subtitle-details" value={props.titleDetails} />
      </h3>
      <div className="roi-panel-content">
        {getContent()}
      </div>
    </div>
  );
}

export default RoiPanelBpResult;
